//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("screeningApi", ScreeningApiFactory);

    ScreeningApiFactory.$inject = ["apiClientFactory"];
    function ScreeningApiFactory(apiClientFactory) {

        const routePrefix = "api/screening/";

        return {
            Search: apiClientFactory.post(routePrefix),
        };
    }
})();
